import DigitalMarketingHome from "../../../jsx/components/Dashboard/DigitalMarketingHome/digitalmarketinghome";

const HomeWrapper = () => {
  return <DigitalMarketingHome />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.dmark];
export default constore(HomeWrapper);
